import React from 'react';

export const SpinnerDefault: React.FC = () => {
    return (
        <svg className="inline-flex h-[2.4rem] w-[2.4rem] animate-spin rounded-full border-l-[0.2rem] border-r-[0.2rem] border-t-[0.2rem] border-r-transparent border-t-text-muted border-l-text-muted" />
    );
};
